import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = async () => {
    if (!this.hasAttribute('auto-open')) return;

    await new Promise(resolve => setTimeout(resolve, 180));
    await this.open();
  };

  async open() {

    await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());

    // ✅ FIX: fetch a real section that exists
    const response = await fetch(`/?section_id=main-cart`, { cache: 'no-store' });
    // -------------------------------^ ONLY CHANGE

    const text = await response.text();

    const html = new DOMParser().parseFromString(text, 'text/html');

    // Grab the drawer markup out of the returned section
    const newContent = html.querySelector('cart-drawer-component');

    if (newContent) {
      this.innerHTML = newContent.innerHTML;
    }

    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
